import React from 'react';
import HeaderTags from '../../common/headerTags/HeaderTags';
import RecomendeApp from '../../components/recomende';

const headerTags = {
    title: 'Recomende uma Música - Seja um programador musical', // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
    meta: {
        description: 'Envie sua sugestão musical que você gosta muito e que não faça parte da nossa programação. Após avaliação da equipe de programadores, a sua canção poderá ir ao ar.',
        keywords: 'música favorita, faça parte da programação, música desconhecida, música desejada, pedir música',
        'og:title': 'Recomende uma Música - Seja um programador musical',
        'og:description': 'Envie sua sugestão musical que você gosta muito e que não faça parte da nossa programação. Após avaliação da equipe de programadores, a sua canção poderá ir ao ar.',
        'og:image': 'https://a1media.antena1.com.br/image/share/recomende.png',
    },
};

const Recomende = () => (
    <div className="pageWrapper">
        <HeaderTags title={headerTags.title} meta={headerTags.meta} />
        <RecomendeApp />
    </div>
);

export default Recomende;
